import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  ViewContainerRef,
} from '@angular/core';
import { Observable, of } from 'rxjs';
import { Habit } from 'src/app/habit.model';
import { ConfigComponent } from './config.component';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  modal: ViewContainerRef | null = null;
  configComponentRef: ComponentRef<ConfigComponent> | null = null;

  constructor(
    private resolver: ComponentFactoryResolver,
  ) {}

  openConfig(habits$: Observable<{ [key: string]: Habit }>): void {
    if (!this.modal) {
      console.error('Modal ref doesn\'t exist');
      return;
    }

    const configComponentFactory = this.resolver.resolveComponentFactory(
      ConfigComponent
    );

    this.configComponentRef = this.modal.createComponent(
      configComponentFactory
    );
    this.configComponentRef.instance.habits$ = habits$;
  }

  onClose(): Observable<boolean> {
    if (!this.configComponentRef) {
      return of(false);
    }

    return this.configComponentRef.instance.closeConfig;
  }

  closeConfig(): void {
    if (!this.configComponentRef) {
      return;
    }

    this.configComponentRef.destroy();
  }

  onDeleteDefaultHabit(): Observable<Habit | null> {
    if (!this.configComponentRef) {
      return of(null);
    }

    return this.configComponentRef.instance.deleteDefaultHabit;
  }

  onAddDefaultHabit(): Observable<string | null> {
    if (!this.configComponentRef) {
      return of(null);
    }

    return this.configComponentRef.instance.addDefaultHabit;
  }

  setDom(modal: ViewContainerRef | null): void {
    this.modal = modal;
  }
}
